import { useTheme } from '@emotion/react'

import Image from '@segment/matcha/components/Image'

import privacyMdPng from './assets/Privacy-md.png'
import privacyMdPng2x from './assets/Privacy-md@2x.png'
import privacyMdWebp from './assets/Privacy-md.webp'
import privacyMdWebp2x from './assets/Privacy-md@2x.webp'

import privacyXsPng2x from './assets/Privacy-xs@2x.png'
import privacyXsWebp from './assets/Privacy-xs.webp'
import privacyXsWebp2x from './assets/Privacy-xs@2x.webp'

const PrivacyImage = () => {
  const theme = useTheme()
  return (
    <picture>
      <source
        type="image/webp"
        media={theme.breakpoints.up(`md`, false)}
        srcSet={`${privacyMdWebp}, ${privacyMdWebp2x} 2x`}
      />
      <source media={theme.breakpoints.up(`md`, false)} srcSet={`${privacyMdPng}, ${privacyMdPng2x} 2x`} />
      <source type="image/webp" srcSet={`${privacyXsWebp}, ${privacyXsWebp2x} 2x`} />
      <Image src={privacyXsPng2x} alt="Privacy" width="640" height="459" loading="lazy" />
    </picture>
  )
}

export default PrivacyImage
